import type { VoidFunctionComponent } from 'react';
import { Modal } from 'react-bootstrap';

import Button, { ButtonGroup } from '../../../generic/Button';

type Props = {
  release: { title: string };
  isShowing: boolean;
  onHide: () => void;
  onConfirm: () => void;
};

const ConfirmReleaseDelete: VoidFunctionComponent<Props> = ({ release, isShowing, onHide, onConfirm }) => {
  return (
    <Modal className="modal-confirm" onHide={onHide} animation show={isShowing}>
      <Modal.Header closeButton>
        <Modal.Title>Are you sure you want to delete release &quot;{release.title}&quot;</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Deleting a release will permanently remove it from this release group.
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button onClick={onHide} size="medium" type="secondary">
            Cancel
          </Button>
          <Button onClick={onConfirm} size="medium" type="error">
            Delete Release
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmReleaseDelete;
